import React from "react";
import { unescapeString } from "@/canv/utils";

type EmbedIframeProps = {
    src: string;
    onLoad: () => void;
};

export function EmbedIframe({ src, onLoad }: EmbedIframeProps) {
    return (
        <>
            <div className="overlayFrame" />
            <iframe
                src={unescapeString(src)}
                className="embedFrame"
                width="auto"
                height="auto"
                sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-modals"
                title="embedWidget"
                onLoad={onLoad}
            />
        </>
    );
}
